// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iqNg","newExpiryDate":"styles_newExpiryDate__qUzj6","footer":"styles_footer__1st9Z"};